import React, { ReactElement, SetStateAction } from "react";
import FontAwesomeIcon from "components/shared/FontAwesomeIcon";
import { InputAdornment, TextField } from "@mui/material";
import styles from "./styles.module.scss";
import { I18n, Translate } from "react-redux-i18n";

interface Iprops {
  label?: string;
  searchValue?: string;
  setSearchValue?: React.Dispatch<React.SetStateAction<string>>;
  setClicked?: React.Dispatch<React.SetStateAction<boolean>>;
  showIcon?: boolean;
  type?: string;
  searchPosition?: string;
  withIcon?: boolean;
  whiteBg?: boolean
  autoFocus?: boolean
  caller?: string
  showMenu?: React.Dispatch<SetStateAction<boolean>>
  isMenuVisible?: boolean,
  handleFocus?: React.Dispatch<SetStateAction<boolean>>
}
export default function Search({
  searchValue,
  setSearchValue,
  setClicked,
  autoFocus,
  caller,
  showMenu,
  isMenuVisible,
  label,
  handleFocus
}: Iprops): ReactElement {
  const handleChange = (value: string) => {
    switch (caller) {
      case "live-event":
        break;
      case "casino":
        setSearchValue && setSearchValue(value)
        break;
      case "sport-event":
        setSearchValue && setSearchValue(value)
        break;
      case "sport-market":
        setSearchValue && setSearchValue(value)
        break;
      default:
        setSearchValue && setSearchValue(value)
    }
  }
  // const handleClick = () => {
  //   setIsSearchClicked(true)
  //   switch (caller) {
  //     case "live-event":
  //       dispatch(setSearchClicked(true))
  //       break;
  //     case "casino":
  //       setClicked && setClicked(true)
  //       break;
  //     case "sport-event":
  //       setClicked && setClicked(true)
  //       break;
  //     case "sport-market":
  //       break;
  //     default:
  //       setClicked && setClicked(true)
  //   }
  // }
  return (
    <TextField
      value={
        caller === "sport-event" ?
          searchValue
          : caller === "sport-market" ?
            searchValue
            : caller === "casino" ?
              searchValue
              : searchValue
      }
      onChange={(event) => handleChange(event.target.value)}
      // onClick={handleClick}
      variant="outlined"
      size="small"
      InputProps={{
        startAdornment:
          <InputAdornment
            position="start"
            className={styles.inputAdornment}>
            <FontAwesomeIcon name="magnifying-glass" type="fas" />
          </InputAdornment>,
        endAdornment:
          searchValue && searchValue.length > 0 ?
            <InputAdornment
              position="end"
              onClick={() => setSearchValue && setSearchValue("")}
              className={styles.closeIcon}
            >
              <FontAwesomeIcon name="x" type="fas" />
            </InputAdornment>
            : <></>
      }}
      autoFocus={autoFocus ? true : false}
      onClick={() => showMenu && isMenuVisible && showMenu(isMenuVisible)}
      /* Forced label styles because only label accepts translation*/
      // label={(localValue && localValue?.length > 0) ? "" : <Translate value={[`search`, `.${label}`].join("")} />}
      placeholder={label === "searchCasino" ? I18n.t("search.searchCasino") : ""}
      onClickCapture={() => handleFocus && handleFocus(true)}
      className={`${styles.sharedSearch} ${caller === "casino" && styles.lightBackground}`}
    />
  )
}

